<template>
  <div>
    <el-table
      v-if="showTable"
      :data="totalScoreList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      :default-sort = "{prop: 'index', order: 'ascending'}"
      empty-text="ไม่พบข้อมูล"
    >
      <el-table-column
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        sortable
        :width="
          widthMax < 767.98
            ? '60'
            : widthMax < 1199
            ? '60'
            : widthMax > 1200
            ? '80'
            : ''
        "
      ></el-table-column>
      <el-table-column
        prop="index"
        label="ชื่อวิชา"
        header-align="center"
        
        sortable
        :width="widthMax < 767.98 ? '200' : ''"
      >
        <template slot-scope="scope">
          วิชาที่ {{ scope.row.index }} {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="preTest"
        label="แบบทดสอบก่อนเรียน"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '100'
            : widthMax < 800
            ? '80'
            : widthMax < 1199
            ? '90'
            : widthMax > 1200
            ? '120'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.preTest.have">
            {{ scope.row.preTest.active }}/{{ scope.row.preTest.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="discussionForum"
        label="กระดานถาม - ตอบระหว่างเรียน"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '100'
            : widthMax < 800
            ? '80'
            : widthMax < 1199
            ? '90'
            : widthMax > 1200
            ? '120'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.discussion.have">
            {{ scope.row.discussion.active }}/{{ scope.row.discussion.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="assignment"
        label="งานที่ได้รับมอบหมาย"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '100'
            : widthMax < 800
            ? '80'
            : widthMax < 1199
            ? '90'
            : widthMax > 1200
            ? '120'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.assignment.have">
            {{ scope.row.assignment.active }}/{{ scope.row.assignment.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="postTest"
        label="แบบทดสอบหลังเรียน"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '100'
            : widthMax < 800
            ? '80'
            : widthMax < 1199
            ? '90'
            : widthMax > 1200
            ? '120'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.postTest.have">
            {{ scope.row.postTest.active }}/{{ scope.row.postTest.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="clipTopic"
        label="วีดิโอ"
        header-align="center"
        align="center"
        :width="
          widthMax < 767.98
            ? '100'
            : widthMax < 800
            ? '80'
            : widthMax < 1199
            ? '90'
            : widthMax > 1200
            ? '120'
            : ''
        "
      >
        <template slot-scope="scope">
          <span v-if="scope.row.topics.have">
            {{ scope.row.topics.active }}/{{ scope.row.topics.total }}
          </span>
          <span v-else>
            -
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="วันที่และเวลาที่อัปเดต"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 991
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.updatedAt | dateTimeTh }}
        </template>
      </el-table-column>
      <el-table-column label width="50" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="
                  $router.push(
                    `/activity/total/score?courseId=${courseId}&subjectId=${scope.row._id}`
                  )
                "
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    totalScoreList: {
      type: Array,
      default() {
        return [];
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {},
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true
    };
  },
  mounted() {
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
  },
};
</script>